import styled from '@emotion/styled'

export const StyleDocumentItems = styled.div`
  display: flex;
  overflow-x: auto;
  flex-wrap: nowrap;
  column-gap: 20px;
  -ms-overflow-style: none;
  scrollbar-width: none;
  ::-webkit-scrollbar {
    display: none;
  }
`

export const StyleDocumentItem = styled.div`
  flex-grow: 0;
  flex-shrink: 0;
  flex-basis: 40%;

  @media (max-width: 1200px) {
    flex-basis: 35%;
  }
  @media (max-widht: 1024px) {
    flex-basis: 30%;
  }
  @media (max-width: 640px) {
    flex-basis: 25%;
  }
  @media (max-width: 500px) {
    flex-basis: 50%;
  }
`

export const styleDocumentUploadWrapper = `
    background:#E9E9E9;
    border-radius:8px;
    div{
        display:flex;
        flex-direction:column;
        button{
            height:80px;
            
            display:flex;
            flex-direction:column;
            justufy-content:center;
            align-items:center;
            row-gap:5px;
            color:#4B4B4B;
        }
    }
`
